import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar, SnackbarContent } from '@mui/material';
import { hideNotification } from '../redux/slices/notificationSlice';

const Notification = () => {
  const dispatch = useDispatch();
  const { open, message, type } = useSelector((state) => state.notification);

  const handleClose = () => {
    dispatch(hideNotification());
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={2000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <SnackbarContent
        message={message}
        style={{
          backgroundColor: type == "success" ? "green" : "red",
          color: '#fff',
          borderRadius: '4px',
          padding: '10px 15px',
        }}
      />
    </Snackbar>
  );
};


export default Notification;


